module.exports = __webpack_public_path__ + "img/stock_shopbag_prices.22a28c9b.png";